"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleOutlineBlockingSystem = void 0;
var core_1 = require("@inter-ikea-core/core");
var SystemBase2_1 = require("../systembase/SystemBase2");
var SimpleOutlineSelectedSystem_1 = require("./SimpleOutlineSelectedSystem");
/**
 * This system is synchronizing the {@link OutlineBlockingComponent} and {@link ViewerObjectComponent} with
 * the viewer, making sure that outlines will be shown as blocking or not.
 *
 * When enabling it, it won't update already existing entities.
 *
 */
var SimpleOutlineBlockingSystem = /** @class */ (function (_super) {
    __extends(SimpleOutlineBlockingSystem, _super);
    function SimpleOutlineBlockingSystem() {
        var _this = _super.call(this, core_1.ComponentIds.VIEWER_OBJECT_COMPONENT_ID, core_1.ComponentIds.OUTLINE_BLOCKING_COMPONENT_ID) || this;
        _this.id = SimpleOutlineBlockingSystem.systemID;
        _this.doingChangesOnComponent = [];
        _this.systemsAfterMe = [SimpleOutlineSelectedSystem_1.SimpleOutlineSelectedSystem.systemID];
        _this.systemsBeforeMe = null;
        _this.mandatoryComponents = [core_1.ComponentIds.LOADED_MODEL_INFO_COMPONENT_ID];
        return _this;
    }
    SimpleOutlineBlockingSystem.prototype.onAddComponent = function (entity, newComponent) {
        if (entity.hasComponent(core_1.ComponentIds.OUTLINE_BLOCKING_COMPONENT_ID)) {
            newComponent.viewerObject.setBlockOutlined(true);
        }
    };
    SimpleOutlineBlockingSystem.prototype.onUpdateComponent = function (entity, _oldComponent, newComponent) {
        if (entity.hasComponent(core_1.ComponentIds.OUTLINE_BLOCKING_COMPONENT_ID)) {
            newComponent.viewerObject.setBlockOutlined(true);
        }
    };
    SimpleOutlineBlockingSystem.prototype.onRemoveComponent = function (_entity, _oldComponent) {
        // Do nothing.
    };
    SimpleOutlineBlockingSystem.prototype.onAddComponent2 = function (entity, _newComponent) {
        var modelComponent = entity.getComponent(core_1.ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
        modelComponent === null || modelComponent === void 0 ? void 0 : modelComponent.viewerObject.setBlockOutlined(true);
    };
    SimpleOutlineBlockingSystem.prototype.onRemoveComponent2 = function (entity, _oldComponent) {
        var modelComponent = entity.getComponent(core_1.ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
        modelComponent === null || modelComponent === void 0 ? void 0 : modelComponent.viewerObject.setBlockOutlined(false);
    };
    SimpleOutlineBlockingSystem.prototype.onUpdateComponent2 = function (_entity, _oldComponent, _newComponent) {
        // Do nothing.
    };
    SimpleOutlineBlockingSystem.systemID = 'SimpleOutlineBlockingSystem';
    return SimpleOutlineBlockingSystem;
}(SystemBase2_1.SystemBase2));
exports.SimpleOutlineBlockingSystem = SimpleOutlineBlockingSystem;
//# sourceMappingURL=SimpleOutlineBlockingSystem.js.map